import { render, staticRenderFns } from "./EditNotesFavoriteModal.vue?vue&type=template&id=7297b910&scoped=true&"
import script from "./EditNotesFavoriteModal.vue?vue&type=script&lang=js&"
export * from "./EditNotesFavoriteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297b910",
  null
  
)

export default component.exports